import { EnhancedLeadershipDesignationModel } from '@shared/data-access/models';
import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { map, Observable } from 'rxjs';
import { ICommissionSalespersonScheme } from '@shared/data-access/interfaces';
import { PaginationAdapter } from '@red/data-access';
import { EnhancedLeadershipDesignationCreateDto, EnhancedLeadershipDesignationUpdateDto } from '@shared/data-access/dto';

@Injectable({
  providedIn: 'root',
})
export class EnhancedLeadershipDesignationApiService {
  static ROOT_POINT = 'hrm/leadership-designation';
  static LIST_COMMON = 'hrm/leadership-designation/list-common';

  constructor(private apiService: ApiService) { }

  create(data: EnhancedLeadershipDesignationCreateDto): Observable<EnhancedLeadershipDesignationModel> {
    return this.apiService
      .post(`${EnhancedLeadershipDesignationApiService.ROOT_POINT}`, data)
      .pipe(map((res: ICommissionSalespersonScheme) => EnhancedLeadershipDesignationModel.fromJson(res) as EnhancedLeadershipDesignationModel));
  }

  get(itemId: number): Observable<EnhancedLeadershipDesignationModel> {
    return this.apiService
      .get(EnhancedLeadershipDesignationApiService.ROOT_POINT + '/' + itemId)
      .pipe(map(res => EnhancedLeadershipDesignationModel.fromJson(res) as EnhancedLeadershipDesignationModel));
  }

  update(id: number, data: EnhancedLeadershipDesignationUpdateDto): Observable<any> {
    return this.apiService.patch(EnhancedLeadershipDesignationApiService.ROOT_POINT + '/' + id, data, { excludeFields: [''] });
  }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<EnhancedLeadershipDesignationModel>> {
    return this.apiService
      .get(EnhancedLeadershipDesignationApiService.ROOT_POINT, query, option)
      .pipe(map(data => new PaginationAdapter(EnhancedLeadershipDesignationModel, data)));
  }

  delete(ids: number[], option?: IApiOption): Observable<any> {
    return this.apiService.delete(EnhancedLeadershipDesignationApiService.ROOT_POINT, { ids }, option);
  }

  listCommon(query = {}, option?: IApiOption): Observable<PaginationAdapter<EnhancedLeadershipDesignationModel>> {
    return this.apiService
      .get(EnhancedLeadershipDesignationApiService.LIST_COMMON, query, option)
      .pipe(map(data => new PaginationAdapter(EnhancedLeadershipDesignationModel, data)));
  }
}
